import { CmsApiThreeStepCtaBlockData } from 'modules/cms/api/types/CmsApiThreeStepCta';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpThreeStepCtaBlock } from './CmsAmpThreeStepCtaBlock';
import { CmsThreeStepCtaBlock } from './CmsThreeStepCtaBlock';

export const CmsThreeStepCtaBlockMapping: CmsBlockMapping<CmsApiThreeStepCtaBlockData> =
  {
    invariant: [
      {
        prop: 'mainHeadline',
        msg: 'Main Heading required for Three Step Call-to-Action',
      },
    ],
    width: CmsBlockWidth.GRID,
    Component: CmsThreeStepCtaBlock,
    AmpComponent: CmsAmpThreeStepCtaBlock,
  };
